
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./AccountDetails.js"));
			});
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ../~/preact-cli/lib/lib/webpack/async-component-loader.js!./routes/accountDetails/AccountDetails.js
// module id = +W16
// module chunks = 6